import { useContext, useCallback } from 'react';
import { translations, Language } from '../translations';
import { LanguageContext } from '../contexts/LanguageContext';

export function useTranslation() {
  const { language, setLanguage } = useContext(LanguageContext);

  const t = translations[language];

  const changeLanguage = useCallback(
    (newLanguage: Language) => {
      setLanguage(newLanguage);
      localStorage.setItem('language', newLanguage);
    },
    [setLanguage],
  );

  return {
    t,
    language,
    changeLanguage,
  };
}
